export const posts = [
  {
    slug: "creating-most-popular-deepseek-api-client-go-part-1",
    title: "Creating the Most Popular Deepseek API Client in Go (Part 1): Why I Built deepseek-go",
    date: "2026-03-03",
    category: "Engineering",
    status: "MATURE",
    excerpt: "Part 1 of my deepseek-go series: why I built it, the production problems it solved, and the architecture principles that shaped the package.",
    tags: ["Go", "SDK", "API", "DeepSeek", "Open Source"],
    seoTitle: "Creating the Most Popular Deepseek API Client in Go (Part 1) | Sugam Panthi",
    seoDescription: "A first-person technical story of how deepseek-go started: architecture goals, design constraints, and practical SDK decisions in Go.",
    canonicalPath: "/blog/creating-most-popular-deepseek-api-client-go-part-1",
    series: "deepseek-go-creation-series",
    seriesOrder: 1
  },
  {
    slug: "creating-most-popular-deepseek-api-client-go-part-2",
    title: "Creating the Most Popular Deepseek API Client in Go (Part 2): Architecture and API Design",
    date: "2026-03-03",
    category: "Engineering",
    status: "MATURE",
    excerpt: "Part 2 dives into deepseek-go internals: client options, request/response handlers, streaming, FIM, JSON mode, and provider compatibility.",
    tags: ["Go", "SDK", "Architecture", "Streaming", "API Design"],
    seoTitle: "Creating the Most Popular Deepseek API Client in Go (Part 2) | Sugam Panthi",
    seoDescription: "Technical breakdown of deepseek-go architecture: stream handling, modular request/response flow, provider support, and design tradeoffs.",
    canonicalPath: "/blog/creating-most-popular-deepseek-api-client-go-part-2",
    series: "deepseek-go-creation-series",
    seriesOrder: 2
  },
  {
    slug: "creating-most-popular-deepseek-api-client-go-part-3",
    title: "Creating the Most Popular Deepseek API Client in Go (Part 3): Growth, Stats, and OSS Momentum",
    date: "2026-03-03",
    category: "Engineering",
    status: "MATURE",
    excerpt: "Part 3 analyzes adoption and growth with live GitHub stats, release cadence, star-history graphs, and what those trends changed in my engineering priorities.",
    tags: ["Go", "Open Source", "GitHub", "Metrics", "Engineering Leadership"],
    seoTitle: "Creating the Most Popular Deepseek API Client in Go (Part 3) | Sugam Panthi",
    seoDescription: "A data-backed look at deepseek-go growth using GitHub API snapshots, star trends, release cadence, and maintenance lessons.",
    canonicalPath: "/blog/creating-most-popular-deepseek-api-client-go-part-3",
    series: "deepseek-go-creation-series",
    seriesOrder: 3
  },
  {
    slug: "creating-most-popular-deepseek-api-client-go-part-4",
    title: "Creating the Most Popular Deepseek API Client in Go (Part 4): Contributors, Lessons, and Roadmap",
    date: "2026-03-03",
    category: "Engineering",
    status: "MATURE",
    excerpt: "Part 4 closes the series with contributor thanks, hard SDK lessons, and my roadmap for deepseek-go's next stage.",
    tags: ["Go", "Open Source", "Maintainer", "Roadmap", "Community"],
    seoTitle: "Creating the Most Popular Deepseek API Client in Go (Part 4) | Sugam Panthi",
    seoDescription: "Final part of the deepseek-go series: contributor acknowledgments, maintenance lessons, and practical roadmap priorities for the SDK.",
    canonicalPath: "/blog/creating-most-popular-deepseek-api-client-go-part-4",
    series: "deepseek-go-creation-series",
    seriesOrder: 4
  },
  {
    slug: "creating-most-popular-deepseek-api-client-go-part-5-testing",
    title: "Creating the Most Popular Deepseek API Client in Go (Part 5): My Testing Strategy in Go",
    date: "2026-03-03",
    category: "Engineering",
    status: "MATURE",
    excerpt: "Part 5 details my Go testing strategy for deepseek-go: layered tests, stream safety checks, and release confidence practices.",
    tags: ["Go", "Testing", "SDK", "Quality", "Open Source"],
    seoTitle: "Creating the Most Popular Deepseek API Client in Go (Part 5) | Sugam Panthi",
    seoDescription: "How I test deepseek-go in Go: unit layers, stream correctness checks, error consistency, and contributor-safe quality gates.",
    canonicalPath: "/blog/creating-most-popular-deepseek-api-client-go-part-5-testing",
    series: "deepseek-go-creation-series",
    seriesOrder: 5
  },
  {
    slug: "creating-most-popular-deepseek-api-client-go-part-6-ollama",
    title: "Creating the Most Popular Deepseek API Client in Go (Part 6): Ollama Integration",
    date: "2026-03-03",
    category: "Engineering",
    status: "MATURE",
    excerpt: "Part 6 explains how I integrated Ollama into deepseek-go with explicit adapters, stream resilience, and practical provider compatibility.",
    tags: ["Go", "Ollama", "SDK", "LLM", "Integration"],
    seoTitle: "Creating the Most Popular Deepseek API Client in Go (Part 6) | Sugam Panthi",
    seoDescription: "Technical deep-dive into deepseek-go's Ollama integration: adapter design, streaming behavior, compatibility boundaries, and lessons learned.",
    canonicalPath: "/blog/creating-most-popular-deepseek-api-client-go-part-6-ollama",
    series: "deepseek-go-creation-series",
    seriesOrder: 6
  },
  {
    slug: "building-my-portfolio-aesthetic",
    title: "Building My Portfolio Aesthetic",
    date: "2024-10-25",
    category: "Design",
    status: "MATURE",
    excerpt: "How I designed a paper-aesthetic texture and integrated it into a modern React portfolio using Tailwind CSS.",
    tags: ["React", "Tailwind", "Design"]
  },
  {
    slug: "getting-started-with-go",
    title: "Getting Started with Go for Web Services (Part 1): Foundations",
    date: "2024-11-05",
    category: "Engineering",
    status: "MATURE",
    excerpt: "Part 1 of a detailed Go web services series: setup, server lifecycle, configuration, error handling, and Python-to-Go workflow.",
    tags: ["Go", "Backend", "API", "Web Services", "System Design"],
    seoTitle: "Getting Started with Go for Web Services (Part 1) | Sugam Panthi",
    seoDescription: "Detailed guide to Go web service foundations: graceful shutdown, timeouts, config strategy, API error envelopes, and practical architecture.",
    canonicalPath: "/blog/getting-started-with-go",
    series: "go-web-services-guide",
    seriesOrder: 1
  },
  {
    slug: "getting-started-with-go-data-middleware-auth",
    title: "Getting Started with Go for Web Services (Part 2): Data, Middleware, Auth",
    date: "2024-11-06",
    category: "Engineering",
    status: "MATURE",
    excerpt: "Part 2 of the Go web services series: repository boundaries, middleware ordering, authentication, database handling, and observability.",
    tags: ["Go", "API", "Middleware", "Auth", "Observability"],
    seoTitle: "Go Web Services Guide (Part 2): Data, Middleware, Auth | Sugam Panthi",
    seoDescription: "Production-oriented Go API patterns for middleware stacks, auth validation, request IDs, database boundaries, and observability.",
    canonicalPath: "/blog/getting-started-with-go-data-middleware-auth",
    series: "go-web-services-guide",
    seriesOrder: 2
  },
  {
    slug: "getting-started-with-go-testing-deploy-scaling",
    title: "Getting Started with Go for Web Services (Part 3): Testing, Deployment, Scaling",
    date: "2024-11-07",
    category: "Engineering",
    status: "MATURE",
    excerpt: "Part 3 of the Go web services series: testing pyramid, deployment safety checks, rollout strategy, scaling sequence, and production checklist.",
    tags: ["Go", "Testing", "Deployment", "Scaling", "SRE"],
    seoTitle: "Go Web Services Guide (Part 3): Testing, Deployment, Scaling | Sugam Panthi",
    seoDescription: "End-to-end release and scale guide for Go APIs including quality gates, canary rollout, rollback strategy, and production hardening.",
    canonicalPath: "/blog/getting-started-with-go-testing-deploy-scaling",
    series: "go-web-services-guide",
    seriesOrder: 3
  },
  {
    slug: "reflections-on-ai-internship",
    title: "Reflections on my AI/ML Internship",
    date: "2024-12-10",
    category: "Career",
    status: "DRAFT",
    excerpt: "Key takeaways and learnings from my time as an AI and ML intern at Prediction3d, working on model optimization.",
    tags: ["AI", "Machine Learning", "Career"]
  }
];
